import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import Header from './Header'; // Import Header
import SideHintObserver from './components/SideHintObserver';

const HomePage = lazy(() => import('./HomePage'));
const PlanPrivate = lazy(() => import('./pages/PlanPrivate'));
const PlanO3Pro = lazy(() => import('./pages/PlanO3Pro'));
const PlanGrok = lazy(() => import('./pages/PlanGrok'));
const PlanGemini = lazy(() => import('./pages/PlanGemini'));
const PlanClaudePro = lazy(() => import('./pages/PlanClaudePro'));
const PlanFamily = lazy(() => import('./pages/PlanFamily'));
const PlanStudent = lazy(() => import('./pages/PlanStudent'));
const PlanThreeMonth = lazy(() => import('./pages/PlanThreeMonth'));
const PlanThreeMonthNoGuarantee = lazy(() => import('./pages/PlanThreeMonthNoGuarantee'));
const PlanOneMonthNoGuarantee = lazy(() => import('./pages/PlanOneMonthNoGuarantee'));
const PaymentCallback = lazy(() => import('./components/PaymentCallback'));
const BlogList = lazy(() => import('./pages/BlogList'));
const BlogPost = lazy(() => import('./pages/BlogPost'));
const AdminCodeVerifier = lazy(() => import('./pages/AdminCodeVerifier'));
const CodeTester = lazy(() => import('./pages/CodeTester'));
const CoursePage = lazy(() => import('./pages/CoursePage'));
const AboutUs = lazy(() => import('./pages/AboutUs'));
const Founder = lazy(() => import('./pages/Founder'));
const CoFounder = lazy(() => import('./pages/CoFounder'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsOfService = lazy(() => import('./pages/TermsOfService'));
const ContactUs = lazy(() => import('./pages/ContactUs'));
const Products = lazy(() => import('./pages/Products'));
const TestBlogList = lazy(() => import('./pages/test_blog_list'));
const AITools = lazy(() => import('./pages/AITools'));
const CMSProduct = lazy(() => import('./pages/CMSProduct'));
const ThompsonDashboard = lazy(() => import('./pages/ThompsonDashboard'));

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          {/* Global animated aurora background for all pages */}
          <div className="aurora-bg">
            <div className="aurora-orb aurora-cyan orb1"></div>
            <div className="aurora-orb aurora-purple orb2"></div>
            <div className="aurora-orb aurora-cyan orb3"></div>
            <div className="aurora-orb aurora-purple orb4"></div>
            <div className="aurora-orb aurora-cyan orb5"></div>
            <div className="aurora-orb aurora-purple orb6"></div>
            <div className="aurora-orb aurora-cyan orb7"></div>
          </div>
          {/* Content wrapper to ensure it's on top of the background */}
          <div className="relative z-10">
          <Header /> {/* Move Header outside of Suspense */}
          <SideHintObserver />
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              {/* <Route path="/signup" element={<SignupLoginPage />} /> */}
              {/* <Route path="/login" element={<SignupLoginPage />} /> */}
              <Route path="/plans/private" element={<PlanPrivate />} />
              <Route path="/plans/o3pro" element={<PlanO3Pro />} />
              <Route path="/plans/grok" element={<PlanGrok />} />
              <Route path="/plans/gemini" element={<PlanGemini />} />
              <Route path="/plans/claude-pro" element={<PlanClaudePro />} />
              <Route path="/plans/family" element={<PlanFamily />} />
              <Route path="/plans/student" element={<PlanStudent />} />
              <Route path="/plans/chatgpt-plus-first-subscription" element={<PlanThreeMonth />} />
              <Route path="/plans/three-month-no-guarantee" element={<PlanThreeMonthNoGuarantee />} />
              <Route path="/plans/one-month-no-guarantee" element={<PlanOneMonthNoGuarantee />} />
              <Route path="/course/codex" element={<CoursePage />} />
              <Route path="/payment-callback" element={<PaymentCallback />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/admin/verify-code" element={<AdminCodeVerifier />} />
              {/* <Route path="/test/code-generator" element={<CodeTester />} /> */}
              <Route path="/about" element={<AboutUs />} />
              <Route path="/team/amirelmtalab" element={<Founder />} />
              <Route path="/team/erfanelmtalab" element={<CoFounder />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/products" element={<Products />} />
              <Route path="/product/:slug" element={<CMSProduct />} />
              <Route path="/test-blog-list" element={<TestBlogList />} />
              <Route path="/admin/thompson-dashboard" element={<ThompsonDashboard />} />
            </Routes>
          </Suspense>
          </div>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
